import React from 'react';
import {classNames} from 'utils';
import styles from './divider.module.css';

export const Divider = ({maxWidth, size = 'md', align = 'center', children}: Props) => {
  const style = {
    maxWidth: maxWidth ? maxWidth : undefined,
    margin: `var(--iq-gap-${size}) auto`,
  };
  return (
    <div className={styles.divider} style={style}>
      <div className={classNames([styles.children, styles[size], styles[align]])}>{children}</div>
    </div>
  );
};

type Props = {
  maxWidth?: string;
  size?: 'sm' | 'md' | 'lg';
  align?: 'left' | 'center' | 'right';
  children?: React.ReactNode;
};
